import * as uiConsts from "./consts"
class RegionSelector {
  constructor() {
    this.region = document.querySelector(".region")
    this.regionFlyout = document.querySelector(".region__dropdown-content")

    if (!this.region || !this.regionFlyout) {
      return;
    }

    this.initRegionMobile()
  }

  initRegionMobile() {
    document.querySelector(".region-mobile").addEventListener("change", e => {
      e.preventDefault()
      let selectedReg = document.querySelector(".mobileregionSelect");
      
      if (!selectedReg) {
        return;
      }

      let slectedRegValue = selectedReg.options[selectedReg.selectedIndex].value
      window.location.assign(slectedRegValue)
    })

    this.region.addEventListener("click", () => {
      if (this.regionFlyout.classList.contains(uiConsts.COLLAPSE_OPACITY_CLASS))
        this.regionFlyout.classList.remove(uiConsts.COLLAPSE_OPACITY_CLASS)
      else this.regionFlyout.classList.add(uiConsts.COLLAPSE_OPACITY_CLASS)
    })
  }
}

export default RegionSelector
